import { defineComponent as _defineComponent } from 'vue';
import { useRoutesStore } from '@/store/modules/routes';
import { handleActivePath } from '@/utils/routes';

import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const route = useRoute();
    const routesStore = useRoutesStore();
    const {
      tab,
      activeMenu
    } = storeToRefs(routesStore);
    watch(route, () => {
      if (tab.value.data !== route.matched[0].name) tab.value.data = route.matched[0].name;
      activeMenu.value.data = handleActivePath(route);
    }, {
      immediate: true
    });
    const __returned__ = {
      route,
      routesStore,
      tab,
      activeMenu
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});